module.exports = Vue;


//////////////////
// WEBPACK FOOTER
// external "Vue"
// module id = 89
// module chunks = 0